export const BOTTOM_BAR_HEIGHT = 78;
export const TRANSITION_DURATION = 225;
export const MENU_ID = 'nav-menu-bottombar';
